import { generatePath } from 'react-router';

export enum AppRoutes {
  Root = '/',
  AccessDenied = '/forbidden',
  NoPermission = '/no-permission',
  Impressum = '/impressum',

  Studies = '/studies',

  // Study routes
  Dashboard = '/studies/:studyId',
  StudyInfoPage = '/studies/:studyId/info',
  StudyUsersPage = '/studies/:studyId/users',
  FAQPage = '/studies/:studyId/faq',
  Monitoring = '/studies/:studyId/monitoring',
  Participants = '/studies/:studyId/participants',
  // Study settings routes
  StudySettings = '/studies/:studyId/settings',
  FormBuilder = 'form-builder',
  GeneralFormBuilder = 'general-form-builder',
  SurveyBuilder = 'survey-builder',
  Analyzes = 'analyzes',
  PatientPipelines = 'patient-pipelines',
  AvailableForms = 'available-records',

  // Admin routes
  Admin = '/admin',
  AdminStudies = 'studies',
  Users = 'users',
  Roles = 'roles',
}

export const navigateToRoute = {
  dashboard: (studyId: number) => generatePath(AppRoutes.Dashboard, { studyId: studyId.toString() }),
  studySettings: (studyId: number) => generatePath(AppRoutes.StudySettings, { studyId: studyId.toString() }),
  formBuilder: (studyId: number) => generatePath(AppRoutes.FormBuilder, { studyId: studyId.toString() }),
  generalFormBuilder: (studyId: number) => generatePath(AppRoutes.GeneralFormBuilder, { studyId: studyId.toString() }),
  surveyBuilder: (studyId: number) => generatePath(AppRoutes.SurveyBuilder, { studyId: studyId.toString() }),
  analyzes: (studyId: number) => generatePath(AppRoutes.Analyzes, { studyId: studyId.toString() }),
  patientPipelines: (studyId: number) => generatePath(AppRoutes.PatientPipelines, { studyId: studyId.toString() }),
  availableForms: (studyId: number) => generatePath(AppRoutes.AvailableForms, { studyId: studyId.toString() }),
  studyInfoPage: (studyId: number) => generatePath(AppRoutes.StudyInfoPage, { studyId: studyId.toString() }),
  studyUsersPage: (studyId: number) => generatePath(AppRoutes.StudyUsersPage, { studyId: studyId.toString() }),
  faqPage: (studyId: number) => generatePath(AppRoutes.FAQPage, { studyId: studyId.toString() }),
  monitoring: (studyId: number) => generatePath(AppRoutes.Monitoring, { studyId: studyId.toString() }),
  participants: (studyId: number) => generatePath(AppRoutes.Participants, { studyId: studyId.toString() }),
};
